import React, { useEffect, useState } from 'react'
import {
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  TextField,
  MenuItem,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Popover,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper
} from '@mui/material'
import {
  ApiGetShopper,
  ApiGetNearbyShopper,
  ApiPostInviteShopper,
  ApiGetShopperList,
  ApiCriteriaMessage,
  ApiGetCancelledShopper,
  ApiInviteBundle,
  ApiGetApproveAllocationShopper,
  ApiGetAllocations
} from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'
import { CancelOutlined } from '@mui/icons-material'
import { useShopperDetails } from '../../../global/ShopperDetailsUtils.ts'
import Dcrage from './Dcrage.tsx'
import { useParams } from 'react-router-dom'

const withinData = [
  { label: 'Within 10 km', value: '10km' },
  { label: 'Within 25 km', value: '25km' },
  { label: 'Within 50 km', value: '50km' },
  { label: 'Within 150 km', value: '150km' }
]

const InviteShopper = () => {

  const [values, setValues] = useState<{ oldShopperIds: string[] }>({
    oldShopperIds: []
  })
  const { id } = useParams()
  const [shopperList, setShopperList] = useState<any>([])
  const [stateData, setStateData] = useState<any>(null)
  const [searchQuery, setSearchQuery] = useState('')
  const [gender, setGender] = useState<any>('')
  const [startAge, setStartAge] = useState('')
  const [age, setAge] = useState('')
  const [selectedDistance, setSelectedDistance] = useState<string>("")
  const [errorMessages, seterrorMessages] = useState<any>([])
  const [iserror, setiserror] = useState<boolean>(false)
  const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [cancelledShopper, setCancelledShopper] = useState<any>([]);
  const [openCancelledDialog, setOpenCancelledDialog] = useState(false);
  const [experienceFilter, setExperienceFilter] = useState<string>('all')
  const [Liquor, setLiquor] = useState<any>()
  const [previousShoppers, setpreviousShoppers] = useState<any>([])
  const [futureShoppers, setfutureShoppers] = useState<any>([])
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

  const handleGetAppliedAllocation = async () => {
    // const offset = (page - 1) * itemsPerPage
    let data = `?allocationId=${id}`

    try {
      const res: any = await ApiGetAllocations(data)
      setStateData(res.data[0])
    } catch (error: any) {
      console.error("Error during API call:", error)
      toast?.error(error)
    }
  }

  useEffect(() => {
    id && handleGetAppliedAllocation()
  }, [id])



  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500); // ⏳ wait 500ms after user stops typing

    return () => {
      clearTimeout(handler); // clear previous timeout on new keystroke
    };
  }, [searchQuery]);

  // console.log("Selected SHooper", values)
  // console.log("Selected dtaa", stateData)
  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    setValues(prevValues => ({
      oldShopperIds: event.target.checked
        ? [...prevValues.oldShopperIds, value]
        : prevValues.oldShopperIds.filter(val => val !== value)
    }))
  }
  useEffect(() => {
    if (gender && startAge && age && stateData && (debouncedSearch || selectedDistance)) {
      const fetchData = async () => {
        await ApiCallGetShopperList()
      }
      fetchData()
    }
    return () => { }
  }, [gender, startAge, age, stateData, selectedDistance, debouncedSearch, experienceFilter])



  const ApiCallGetShopperList = async () => {

    const experienceParam = (experienceFilter === 'new' || experienceFilter === 'experienced')
      ? `&experience=${experienceFilter}`
      : ''
    const venueJobYearParam = (experienceFilter === 'last' && stateData?.venueId?.venueId && stateData?.jobYear && stateData?.jobMonth)
      ? `&venueId=${stateData.venueId.venueId}&year=${stateData.jobYear}&month=${stateData.jobMonth}`
      : ''
    const data = `?offset=0&limit=1000&status=active&gender=${gender}&minAge=${startAge}&maxAge=${age}${selectedDistance && `&latitude=${stateData?.venueId.lat}&longitude=${stateData?.venueId.long}&kilometerRange=${selectedDistance}`}&allocationId=${stateData.allocationId}&search=${debouncedSearch}${experienceParam}${venueJobYearParam}&isLiquorId=${Liquor}`
    const res = await ApiGetShopperList(data)
    // const response = res?.data.map(item => ({
    //   label:
    //     item.firstName + item.lastName === ''
    //       ? '-'
    //       : item.firstName + item.lastName,
    //   value: item.userId
    // }))
    const response = res?.data
      .filter(item => item.firstName.trim() !== '' && item.lastName.trim() !== '')
      .map(item => {
        const dob = new Date(item.dob); // assuming item.dob exists and is a valid date string
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const m = today.getMonth() - dob.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
          age--;
        }

        return {
          userId: item.userId,
          label: `${item.firstName} ${item.lastName}`,
          value: item.userId,
          emailId: item.emailId,
          age: age, // calculated from dob
          contactNo: item.contactNo,
          distanceInKm: item.distanceInKm
        };
      });

    setShopperList(response);

  }

  const handleDistanceChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    if (event.target.checked) {
      setSelectedDistance(value)
      // Here you would typically call an API to get shoppers within this distance
      //fetchNearbyShoppers(value)
    } else {
      setSelectedDistance("")
    }
  }


  useEffect(() => {
    const storedDataUp = sessionStorage.getItem('inviteShopperState')
    const isLiquor = sessionStorage.getItem('isLiquor')
    if (storedDataUp) {
      setStateData(JSON.parse(storedDataUp))
    }
    setLiquor(isLiquor);
  }, [])

  useEffect(() => {
    setGender(stateData?.gender || '')
    setStartAge(stateData?.minAge || '')
    setAge(stateData?.maxAge || '')
  }, [stateData])

  const filteredVenues = shopperList.filter(option =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
    option.emailId.toLowerCase().includes(searchQuery.toLowerCase())
  )

  const handleSendInviteToShopper = async (isSkip: boolean = false) => {
    // const failedUserIds = errorMessages.map((item: any) => item.userId);
    const ignoredUserIds = new Set(
      errorMessages
        .filter((item: any) => !item.isNeedtoAdd)
        .map((item: any) => item.userId)
    );
    const data = {
      userIds: isSkip ? values.oldShopperIds.filter(
        (id) => !ignoredUserIds.has(id)
      ) : values.oldShopperIds,
      allocationId: stateData?.allocationId,
      createdBy: Number(localStorage.getItem('createdBy')),
    }
    try {
      const response = await ApiPostInviteShopper(data)
      toast.success('Selected Shoppers Invited Successfully!')
    }
    catch (error: any) {
      console.error('Error updating store:', error)
      toast.error(error?.message);
    }
  }

  const handleInviteBundle = async (isSkip: boolean = false) => {
    const ignoredUserIds = new Set(
      errorMessages
        .filter((item:any) => !item.isNeedtoAdd) // unchecked users
        .map((item:any) => item.userId)
    );
    try {
      const data = {
        "userIds": isSkip ? values.oldShopperIds.filter(
          (id) => !ignoredUserIds.has(id)
        ) : values.oldShopperIds,
        "bundleId": stateData?.bundleId?.bundleId ?? stateData?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId,
        ...(stateData?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId && { "isWithoutVenueBundle": true }),
        "createdBy": Number(localStorage.getItem('createdBy'))
        
      }
      const res = await ApiInviteBundle(data)
      if (res?.status) {
        toast.success('Selected Shoppers Invited Successfully!')

      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  const handlecriteriamessage = async () => {
    seterrorMessages([])
    if (errorMessages.length <= 0) {
      const data = `?userId=${values.oldShopperIds.join(',')}&allocationId=${stateData.allocationId}${stateData?.clientEntityId?.clientEntityId ? `&clientEntityId=${stateData?.clientEntityId?.clientEntityId}` : ""}`
      try {
        const response = await ApiCriteriaMessage(data)
        const tempErrors: any = [];
        response.data.map((item, index) => {
          if (item.allocationCriteriaFailures.length > 0) {
            tempErrors.push({
              userId: item?.userId,
              username: item.username,
              messages: item.allocationCriteriaFailures,
              isNeedtoAdd: false,

            })
          }
        })
        seterrorMessages(tempErrors)
        if (tempErrors.length <= 0) { (stateData?.bundleId?.bundleId || stateData?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId) ? handleInviteBundle(false) : handleSendInviteToShopper(false) }
      }
      catch (error) {
        console.error('Error updating store:', error)
        toast.error(error);
      }

    }
  }


  useEffect(() => {
    errorMessages.length > 0 ? setiserror(true) : setiserror(false)
  }, [errorMessages])

  const handleSelectAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked
    setSelectAll(isChecked)

    if (isChecked) {
      const allShopperIds = filteredVenues.map((option: any) => option.value)
      setValues({ oldShopperIds: allShopperIds })
    } else {
      setValues({ oldShopperIds: [] })
    }
  }

  useEffect(() => {
    if (filteredVenues.length > 0) {
      const allSelected = filteredVenues.every((option: any) =>
        values.oldShopperIds.includes(option.value)
      )
      setSelectAll(allSelected)
    }
  }, [values.oldShopperIds, filteredVenues])


  const handleCancelledShopper = async () => {
    try {
      const response = await ApiGetCancelledShopper(`?allocationId=${stateData.allocationId}`)
      setCancelledShopper(response.data);
      setOpenCancelledDialog(true);
    } catch (error) {
      console.error("Error Generating cancelled shopper.", error);
      toast.error("Error getting cancelled shopper.")
    }
  }

  useEffect(() => {

    const getpreviousShoppers = async () => {
      try {
        const data = `?venueId=${stateData?.venueId?.venueId}&jobMonth=${stateData?.jobMonth}&jobYear=${stateData?.jobYear}`
        const res = await ApiGetApproveAllocationShopper(data)
        if (res?.status) {
          setpreviousShoppers(res?.data?.previousMonth)
          setfutureShoppers(res?.data?.futureMonth)
        }
      } catch (error: any) {
        toast.error(error?.message)
      }
    }
    stateData && getpreviousShoppers()
  }, [stateData])

  return (
    <div className='invite-shopper'>
      <h1 className='common-add' style={{ textAlign: 'center' }}>
        {(stateData?.bundleId?.bundleId) ? `Bundle` : stateData?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId ? "Transport Bundle" : `Orphan Allocation`}  - Invite-Shopper
      </h1>
      <div>
        <div className='d-flex justify-content-between align-items-center'>
          <Typography variant='h6' fontWeight={'bold'} gutterBottom>
            {stateData?.bundleId?.bundleName ? stateData?.bundleId?.bundleName : stateData?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId ? stateData?.withoutVenueBundleAllocationId?.bundleName : stateData?.venueId?.venueName}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="small"
            className="table-row-background"
            onClick={() => handleCancelledShopper()}
          >Cancelled Shoppers</Button>
        </div>
        {!stateData?.bundleId && !stateData?.withoutVenueBundleAllocationId &&
          (
            <Box className='d-flex align-items-start justify-content-between'>
              <div>
                <Typography>
                  <b>Address:</b> {stateData?.venueId?.address} {stateData?.venueId?.city}  {stateData?.venueId?.suburb ? `,${stateData?.venueId?.suburb},` : ''} {stateData?.venueId?.state} {stateData?.venueId?.postalCode}
                </Typography>
                <Typography>
                  <b>Trading hours:</b> {stateData?.venueId?.tradingHours}
                </Typography>
                <Typography>
                  <b>Website:</b>
                  <a href={stateData?.venueId?.websiteURL}>
                    {stateData?.venueId?.websiteURL}
                  </a>
                </Typography>
                <Typography>
                  <b>Price:</b> {stateData?.allocationPriceDisplay ? stateData?.allocationPriceDisplay : `$${stateData?.allocationPrice}`}
                </Typography>
              </div>
              <div className='d-flex flex-column' style={{ gap: "20px" }}>
                <div>
                  <h6 className='mb-2' style={{ fontWeight: "700" }}>Previous Shoppers:</h6>
                  <div className='d-flex align-items-center flex-wrap px-2' style={{ gap: "10px", minWidth: "400px", maxWidth: "800px" }}>
                    {[...previousShoppers]
                      ?.reverse()?.map((item: any) =>
                      (
                        <div
                          // className='p-3 2 d-flex flex-column align-items-center border-10'
                          style={{
                            width: "fit-content",
                            // maxWidth:'calc(25% - 10px)', // 4 items per row with gap adjustment
                            cursor: "pointer",
                            textDecoration: 'underline',
                            color: 'rgb(106,103,67)',
                            textDecorationColor: 'rgb(106,103,67)'
                          }}
                          onClick={(e) => handleShopperDetailsClick(e, item?.shopperId)}
                        >
                          {item?.shopperFirstName} {item?.shopperLastName} ({item?.month}-{item?.year})
                        </div>
                      ))}
                  </div>
                </div>
                <div>
                  <h6 className='mb-2' style={{ fontWeight: "700" }}>Future Shoppers:</h6>
                  <div className='d-flex align-items-center flex-wrap px-2' style={{ gap: "10px", minWidth: "400px", maxWidth: "800px" }}>
                    {[...futureShoppers]
                      ?.reverse()?.map((item: any) => (
                        <div
                          // className='p-3 2 d-flex flex-column align-items-center border-10'
                          style={{
                            width: "fit-content",
                            // width: "calc(25% - 10px)", // 4 items per row with gap adjustment
                            cursor: "pointer",
                            textDecoration: 'underline',
                            color: 'rgb(106,103,67)',
                            textDecorationColor: 'rgb(106,103,67)'
                          }}
                          onClick={(e) => handleShopperDetailsClick(e, item.shopperId)}
                        >
                          {/* <div className="bg-light p-2 px-4 border-10"> */}
                          {item?.shopperFirstName} {item?.shopperLastName} ({item?.month}-{item?.year})
                          {/* </div> */}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              {/* <hr /> */}
            </Box>
          )}
        <div className='d-flex align-items-center justify-content-between'>
          <div>
            {withinData.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={selectedDistance === option.value}
                    onChange={(event) => handleDistanceChange(event, option.value)}
                  />
                }
                label={option.label}
              />
            ))}
          </div>
          <div className='d-flex flex-column' style={{ gap: "20px" }}>
            {(stateData?.bundleId || stateData?.withoutVenueBundleAllocationId) && (
              <div >
                <h6 className='mb-2 text-start' style={{ fontWeight: "700" }}>Previous Shoppers:</h6>
                <div className='d-flex align-items-center flex-wrap px-2' style={{ gap: "10px", minWidth: "400px", maxWidth: "800px" }}>
                  {/* {Array.from(
                  new Map(
                    [...(previousShoppers ?? [])]
                      .reverse()
                      .map(item => [
                        `${item?.shopperFirstName}-${item?.shopperLastName}-${item?.month}-${item?.year}`,
                        item
                      ])
                  ).values()
                ).map((item: any, index) => */}
                  {[...previousShoppers]
                    ?.reverse()?.map((item: any, index: number) =>
                    (
                      <div
                        key={index}
                        style={{
                          width: "fit-content",
                          // width: "calc(25% - 10px)", // 4 items per row with gap adjustment
                          cursor: "pointer",
                          textDecoration: 'underline',
                          color: 'rgb(106,103,67)',
                          textDecorationColor: 'rgb(106,103,67)'
                        }}
                        // className="p-3 d-flex flex-column align-items-center border-10"
                        // style={{ gap: "10px", background: "#ADB792", cursor: "pointer" }}
                        onClick={(e) => handleShopperDetailsClick(e, item?.shopperId)}
                      >
                        {/* <div className="bg-light p-2 px-4 border-10"> */}
                        <p className="text-center" style={{ fontSize: '14px' }}>
                          {item?.shopperFirstName} {item?.shopperLastName}
                          ({item?.month}-{item?.year})
                        </p>
                        <p className="text-center">
                        </p>
                        {/* </div> */}
                      </div>
                    ))}
                </div>
              </div>
            )}
            {(stateData?.bundleId || stateData?.withoutVenueBundleAllocationId) && (
              <div>
                <h6 className='mb-2 text-start' style={{ fontWeight: "700" }}>Future Shoppers:</h6>
                <div className='d-flex align-items-center flex-wrap px-2' style={{ gap: "10px", minWidth: '400px', maxWidth: '800px' }}>
                  {/* {Array.from(
                    new Map(
                      [...(futureShoppers ?? [])]
                        .reverse()
                        .map(item => [
                          `${item?.shopperFirstName}-${item?.shopperLastName}-${item?.month}-${item?.year}`,
                          item
                        ])
                    ).values()
                  ).map((item: any, index) =>  */}
                  {[...futureShoppers]
                    ?.reverse()?.map((item: any, index: number) =>
                    (
                      <div
                        key={index}
                        style={{
                          width: "fit-content",
                          // width: "calc(25% - 10px)", // 4 items per row with gap adjustment
                          cursor: "pointer",
                          textDecoration: 'underline',
                          color: 'rgb(106,103,67)',
                          textDecorationColor: 'rgb(106,103,67)'
                        }}
                        // className="p-3 d-flex flex-column align-items-center border-10"
                        // style={{ gap: "10px", background: "#ADB792", cursor: "pointer" }}
                        onClick={(e) => handleShopperDetailsClick(e, item?.shopperId)}
                      >
                        {/* <div className="bg-light p-2 px-4 border-10"> */}
                        <p className="text-center" style={{ fontSize: '14px' }}>
                          {item?.shopperFirstName} {item?.shopperLastName}
                          ({item?.month}-{item?.year})
                        </p>
                        <p className="text-center">
                        </p>
                        {/* </div> */}
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <hr />
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div className='flex items-center gap-2'>
            <span>Start Age: </span>
            <Select
              value={startAge}
              onChange={e => setStartAge(e.target.value)}
            >
              {Array.from({ length: 86 }, (_, i) => (i + 15).toString()).map(
                age => (
                  <MenuItem key={age} value={age}>
                    {age}
                  </MenuItem>
                )
              )}
            </Select>
          </div>

          <div className='flex items-center gap-2'>
            <span>End Age: </span>
            <Select value={age} onChange={e => setAge(e.target.value)}>
              {Array.from({ length: 86 }, (_, i) => (i + 15).toString()).map(
                ageOption => (
                  <MenuItem key={ageOption} value={ageOption}>
                    {ageOption}
                  </MenuItem>
                )
              )}
            </Select>
          </div>
          <div className='flex items-center gap-2'>
            <span>Gender: </span>
            <Select
              value={gender}
              onChange={e => setGender(e.target.value)}
              style={{ width: '150px' }}
            >
              <MenuItem value='Female'>Female</MenuItem>
              <MenuItem value='Male'>Male</MenuItem>
              <MenuItem value='All'>All</MenuItem>
            </Select>
          </div>
        </div>
        <hr />
        <TextField
          fullWidth
          type='text'
          InputLabelProps={{ shrink: true }}
          placeholder='Search Shopper...'
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
        />

        <hr />
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            Please Select Shopper (Shoppername) (Age) (Distance)
            <div className='d-flex justify-content-center align-items-center gap-1'>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={experienceFilter === 'all'}
                    onChange={() => setExperienceFilter('all')}
                  />
                }
                label="All Shoppers"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={experienceFilter === 'new'}
                    onChange={() => setExperienceFilter('new')}
                  />
                }
                label="New Shoppers"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={experienceFilter === 'experienced'}
                    onChange={() => setExperienceFilter('experienced')}
                  />
                }
                label="Experienced Shoppers"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={experienceFilter === 'last'}
                    onChange={() => setExperienceFilter('last')}
                  />
                }
                label="Last Shoppers"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                    disabled={filteredVenues.length === 0}
                  />
                }
                label="Select All Shoppers"
              />
              <Button
                variant='contained'
                color='primary'
                size='small'
                className='table-row-background'
                style={{ marginBottom: '0px', width: '200px' }}
                // onClick={handleSendInviteToShopper}
                onClick={handlecriteriamessage}
              >
                Invite Shopper Select
              </Button>
            </div>
          </div>
          <hr />
          <Box className='d-flex align-items-stretch justify-content-start flex-wrap' gap={1}>
            {filteredVenues.map(option => (
              <Box className='border d-flex align-items-start  px-2 py-2' gap={1} width='24%' borderRadius='10px' >
                <Checkbox
                  className='m-0 mb-0 pb-0'
                  checked={values.oldShopperIds.includes(option.value)}
                  onChange={event => handleCheckboxChange(event, option.value)}
                />
                <Box>
                  <Typography fontWeight='bold' whiteSpace='wrap' variant='subtitle2' sx={{ cursor: "pointer" }} onClick={(e) => handleShopperDetailsClick(e, option.userId)}>{option.label} ({option.age}) ({option.contactNo}) ({option.distanceInKm}km)</Typography>
                  <Typography className='' variant='subtitle2'>{option.emailId}</Typography>
                  {/* <Typography className=''  variant='subtitle2'></Typography> */}
                </Box>
              </Box>

            ))}
          </Box>
        </div>
      </div>
      {errorMessages.length > 0 && (
        <Dialog open={iserror}>
          <DialogContent>
            <Box className='d-flex mb- p-0 align-items-center mb-3 justify-content-between' gap={5}>
              <Typography className='text-center text-danger' fontWeight='bold' variant='h5'>Error Reasons</Typography>
              <IconButton onClick={() => {
                setiserror(false);
              }}><CancelOutlined /></IconButton>
            </Box>
            <Box className='p-1'>
              {errorMessages.map((item: any, index: number) => (
                <Box className='d-flex align-items-start gap-2 mb-2' key={index}>
                  <Checkbox
                    checked={item.isNeedtoAdd}
                    onChange={(e) => {
                      const updated = [...errorMessages];
                      updated[index].isNeedtoAdd = e.target.checked;
                      seterrorMessages(updated);
                    }}
                  />
                  <Box>
                    <Typography fontWeight='bold' variant='h6'>{item.username}</Typography>
                    <ul className='pl-2'>
                      {item.messages.map((msg) => (
                        <li><Typography variant='subtitle2'>{msg}</Typography></li>
                      ))}
                    </ul>
                  </Box>
                </Box>
              ))}
            </Box>
            <Typography variant='body2'><b>Note:</b> Above shoppers did not meet the allocation criteria. Check the shoppers you'd like to invite anyway. Unchecked shoppers in this list will be ignored.</Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'space-between', marginLeft: 2, marginRight: 2 }}>
            <Button
              variant="outlined"
              sx={{ color: '#75724C', borderColor: '#75724C' }}
              onClick={() => {
                setiserror(false); setValues({
                  oldShopperIds: []
                })
              }}
            >
              Cancel
            </Button>
            {/* <Button
              variant="contained"
              color="primary"
              className='table-row-background'
              onClick={() => {
                // setiserror(false);
                (stateData?.bundleId?.bundleId || stateData?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId) ? handleInviteBundle(true) : handleSendInviteToShopper(true);
                // setValues({ oldShopperIds: [] });
              }}
            >
              proceed with selected Shoppers
            </Button> */}
            <Button
              variant="contained"
              color="primary"
              className='table-row-background'
              onClick={() => {
                setiserror(false);
                (stateData?.bundleId?.bundleId || stateData?.withoutVenueBundleAllocationId?.withoutVenueBundleAllocationId) ? handleInviteBundle(true) : handleSendInviteToShopper(true);
                setValues({ oldShopperIds: [] });
              }}
            >
              Proceed
            </Button>
          </DialogActions>
        </Dialog>)}
      <Popover
        // open={Boolean(anchorEl) && selectedIndex === index}
        open={Boolean(anchorEl) && clickedShopperId !== null}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Dcrage handleClose={handleClose} loanData={loanData} />
      </Popover>
      <Dialog open={openCancelledDialog} onClose={() => setOpenCancelledDialog(false)} maxWidth="md" fullWidth>
        <DialogContent>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ mb: 2, textAlign: "center" }}
          >
            Cancelled Shoppers
          </Typography>

          <TableContainer component={Paper} sx={{ border: "1px solid #ccc" }}>
            <Table>
              <TableHead sx={{ bgcolor: "#7a7d52" }}>
                <TableRow>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>First Name</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Last Name</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Email</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Cancel Reason</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {cancelledShopper?.length > 0 ? (
                  cancelledShopper.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.userId?.firstName}</TableCell>
                      <TableCell>{item.userId?.lastName}</TableCell>
                      <TableCell>{item.userId?.emailId}</TableCell>
                      <TableCell>{item.cancelReason}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No cancelled shoppers found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            sx={{ bgcolor: "#7a7d52", "&:hover": { bgcolor: "#5f6245" } }}
            onClick={() => setOpenCancelledDialog(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  )
}

export default InviteShopper
